import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlagsApiResponseOfNull } from '@benefitsui/app/api/benefits-clients';
import { FlagsService } from '@benefitsui/app/services/flags/flags.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class FlagsInterceptor implements HttpInterceptor {
  constructor(private flagsService: FlagsService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(async (response) => {
        if (response instanceof HttpResponse) {
          if (response.body) {
            let body: FlagsApiResponseOfNull | undefined;
            if (response.body instanceof Blob) {
              const text = await getBlobText(response.body);
              body = JSON.parse(text);
            } else if (typeof response.body === 'string') {
              body = JSON.parse(response.body);
            }

            if (body && body.flags) {
              this.flagsService.updateFlags(body.flags);
            }
          }
        }
      })
    );
  }
}

// avoids using `Blob.prototype.text`, which is not present in IE
function getBlobText(blob: Blob): Promise<string> {
  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target?.result as string);
    };
    reader.readAsText(blob);
  });
}
